import client from '../client';
import type { ApiKey, CreateApiKeyInput, UpdateApiKeyInput } from '../../types/apiKey';
import type { ApiResponse } from '../../types/api';

export const apiKeysApi = {
  list: async (storeId: string) => {
    const res = await client.get<ApiResponse<{ apiKeys: ApiKey[] }>>(
      `/dashboard/${storeId}/api-keys`,
    );
    return res.data.data!;
  },

  create: async (storeId: string, data: CreateApiKeyInput) => {
    const res = await client.post<ApiResponse<{ apiKey: string; keyId: string; name: string }>>(
      `/dashboard/${storeId}/api-keys`,
      data,
    );
    return res.data.data!;
  },

  update: async (storeId: string, keyId: string, data: UpdateApiKeyInput) => {
    await client.patch(`/dashboard/${storeId}/api-keys/${keyId}`, data);
  },

  delete: async (storeId: string, keyId: string): Promise<void> => {
    await client.delete(`/dashboard/${storeId}/api-keys/${keyId}`);
  },

  regenerate: async (storeId: string, keyId: string) => {
    const res = await client.post<ApiResponse<{ apiKey: string }>>(
      `/dashboard/${storeId}/api-keys/${keyId}/regenerate`,
    );
    return res.data.data!;
  },
};
